import { type LucideIcon, Clock, Sparkles } from 'lucide-react';

interface ComingSoonPageProps {
  title: string;
  description?: string;
  icon?: LucideIcon;
}

export function ComingSoonPage({
  title,
  description,
  icon: Icon = Clock,
}: ComingSoonPageProps) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center py-24 animate-fade-in">
      <div className="w-full max-w-md text-center">
        {/* Icon with glow */}
        <div className="relative mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-b from-primary-500/20 to-primary-500/5 ring-1 ring-primary-500/20">
          <Icon className="h-7 w-7 text-primary-500" aria-hidden />
          <div className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-primary-500 ring-2 ring-surface">
            <Sparkles className="h-2.5 w-2.5 text-white" aria-hidden />
          </div>
        </div>

        <h2 className="mb-2 text-xl font-semibold tracking-tight text-fg">{title}</h2>

        <p className="mb-6 text-sm leading-relaxed text-fg-muted">
          {description ??
            'This feature is under active development and will be available soon.'}
        </p>

        <div className="rounded-xl border border-primary-200/60 bg-primary-50/60 px-5 py-4 text-sm text-primary-700 dark:border-primary-500/20 dark:bg-primary-500/5 dark:text-primary-300">
          <span className="font-semibold">Need early access?</span>{' '}
          Contact Authmatech support to enable this feature for your account.
        </div>
      </div>
    </div>
  );
}
